<template>
  <v-dialog
    eager
    v-model="dialog"
    max-width="600px"
  >
    <v-card elevation="0">
      <v-col class="text-right px-4">
        <v-btn icon @click="closeForm" ><v-icon large color="primary">close</v-icon></v-btn>
      </v-col>

      <canvas id="buttonCanvas"></canvas>

      <v-container>
        <v-form ref="form">
          <v-row>
            <v-col cols="12">
              <v-card-text>
                <v-row justify="space-around">
                  <v-col cols="12" md="12">
                    <!-- ButtonContent -->
                    <v-select
                      :items="buttonContent"
                      item-text="translatedName"
                      item-value="id"
                      :menu-props="{bottom: true, offsetY: true}"
                      v-model="modeType"
                      outlined
                      clearable
                      :label="$t('display/elevator:edit.labels.button-content-tab.mode')"
                    />

                    <div class="warning-message mb-1" v-show="showWarningGreenMessage">
                      <v-icon>warning</v-icon>
                      {{$t('dialog:boundary-warning')}}
                    </div>
                    <!-- Green button name -->
                    <v-text-field
                      outlined
                      v-model="button.greenButtonName"
                      maxlength="65"
                      counter="65"
                      :class="showWarningGreenMessage ? 'warning-message' : ''"
                      :label="$t('display/elevator:edit.labels.button-content-tab.green-button-name')"
                      class="text-button"
                    >
                      <v-menu
                          bottom
                          offset-y
                          slot="append"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                              class="ma-2"
                              v-bind="attrs"
                              v-on="on"
                              icon
                          >
                            <v-icon
                                color="gray"
                            >
                              dialpad
                            </v-icon>
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item
                              v-for="(item, i) in symbols"
                              :key="i"
                              @click="addSymbol(item, 'greenButtonName')"
                          >
                            <v-list-item-title>{{ item }}</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-text-field>



                    <v-autocomplete
                      v-if="isButtonType"
                      clearable
                      outlined
                      hide-selected
                      :menu-props="{bottom: true, offsetY: true}"
                      :items="buttonContentList"
                      item-text="value"
                      item-value="key"
                      v-model="button.greenButton"
                      :label="$t('display/elevator:edit.labels.button-content-tab.green-button')"
                    />

                    <div class="warning-message mb-1" v-show="showWarningRedMessage">
                      <v-icon>warning</v-icon>
                      {{$t('dialog:boundary-warning')}}
                    </div>
                    <!-- Red button name -->
                    <v-text-field
                      outlined
                      maxlength="65"
                      counter="65"
                      v-model="button.redButtonName"
                      :class="showWarningRedMessage ? 'warning-message' : ''"
                      :label="$t('display/elevator:edit.labels.button-content-tab.red-button-name')"
                      class="text-button"
                    >
                      <v-menu
                          bottom
                          offset-y
                          slot="append"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                              class="ma-2"
                              v-bind="attrs"
                              v-on="on"
                              icon
                          >
                            <v-icon
                                color="gray"
                            >
                              dialpad
                            </v-icon>
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item
                              v-for="(item, i) in symbols"
                              :key="i"
                              @click="addSymbol(item, 'redButtonName')"
                          >
                            <v-list-item-title>{{ item }}</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-text-field>

                    <v-autocomplete
                      v-if="isButtonType"
                      clearable
                      outlined
                      hide-selected
                      :menu-props="{bottom: true, offsetY: true}"
                      :items="buttonContentList"
                      item-text="value"
                      item-value="key"
                      v-model="button.redButton"
                      :label="$t('display/elevator:edit.labels.button-content-tab.red-button')"
                    />

                    <v-autocomplete
                      v-if="!isButtonType && !isAdmin"
                      multiple
                      small-chips
                      clearable
                      outlined
                      hide-selected
                      :items="carouselContentList"
                      item-text="value"
                      item-value="key"
                      :disabled="maxCarouselCount === 0"
                      :value="button.carouselMedia"
                      @change="updateMedia"
                      :counter="maxCarouselCount"
                      deletable-chips
                      :menu-props="carouselMenuProps"
                      :label="$t('common:media_plural')"
                    />

                    <v-autocomplete
                        v-if="!isButtonType && isAdmin"
                        multiple
                        small-chips
                        clearable
                        outlined
                        hide-selected
                        :items="carouselContentList"
                        item-text="value"
                        item-value="key"
                        :value="button.carouselMedia"
                        @change="updateMedia"
                        deletable-chips
                        :menu-props="carouselMenuProps"
                        :label="$t('common:media_plural')"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-col>

            <v-col cols="12" >
              <AdditionalElevator
                  :is-admin="isAdmin"
                  @updateElevators="e => $store.commit('display/elevatorForm/updateAdditionalElevators', e)"
                  ref="additionalElevator"
              />
            </v-col>

            <v-col cols="12">
              <v-card
                elevation="0"
                flat
                tile
                class="pl-3 pt-3 pb-md-3"
              >
                <TwoButtonDialog
                  ref="saveButton"
                  :btn-text="$t('buttons:save')"
                  color="primary"
                  :hideOverlay="true"
                  :dialog-title="$t('dialog:save-btn-title', {name : $t('display/elevator:edit.dialog.dialog-part-1')})"
                  :dialog-text="$t('dialog:save-btn-dialog', {name : $t('display/elevator:edit.dialog.dialog-part-2')})"
                  :button1-text="$t('buttons:save')"
                  :button2-text="$t('buttons:cancel')"
                  @clickedButton1="updateForm()"
                  @clickedButton2="$refs.saveButton.showDialog = false"
                />
                <DirtyConfirmButtonDialog
                  ref="dirtyDialog"
                  :btn-text="$t('buttons:back')"
                  color="grey"
                  :hideOverlay="true"
                  :dialog-title="$t('dialog:dirty-save-btn-title')"
                  :dialog-text="$t('dialog:dirty-save-btn-dialog')"
                  :button1-text="$t('dialog:dirty-save-btn-1-text')"
                  :button2-text="$t('dialog:dirty-save-btn-2-text')"
                  @clickedButton="closeForm"
                />
              </v-card>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>

import EnumUtils from '@/modules/core/services/enum-utils';
import ButtonContentService from '@/modules/display/services/button-content-service';
import ButtonContent from '@/modules/display/data/button-content';
import {Role} from '@/modules/core/data/roles';
import TwoButtonDialog from '@/modules/core/components/TwoButtonDialog/TwoButtonDialog';
import DirtyConfirmButtonDialog from '@/modules/core/components/TwoButtonDialog/DirtyConfirmButtonDialog';
import AdditionalElevator from '@/modules/display/components/AdditionalElevator';
import Utils from '@/modules/core/services/utils';

const visibleWidth = 274;

export default {
  name: "ButtonContentForm",
  components: {
    TwoButtonDialog,
    DirtyConfirmButtonDialog,
    AdditionalElevator
  },
  data() {
    return {
      modeType: null,
      symbols: [],
      buttonContent: [],
      carouselContentList: [],
      buttonContentList: [],
      content: null,
      button: {},
      buttonBeforeChange: {},
      dialog: false,
      isButtonType: true,
      maxCarouselCount: 0,
      carouselMenuProps: {
        disabled: false,
        bottom: true,
        offsetY: true
      }
    }
  },
  computed: {
    isAdmin() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes(Role.Admin);
      }
      return false;
    },

    currentUser() {
      return this.$store.state.auth.user;
    },
    showWarningRedMessage() {
      if (!this.button) return ;
      return this.getTextWidth(this.button.redButtonName) > visibleWidth;
    },
    showWarningGreenMessage() {
      if (!this.button) return ;
      return this.getTextWidth(this.button.greenButtonName) > visibleWidth;
    }
  },
  watch: {
    modeType() {
      this.isButtonType = true;
      this.button.buttonMode = this.modeType;
      if (this.modeType === 'CAROUSEL_MODE') {
        this.isButtonType = false;
      }
    },
    button: {
      deep: true,
      handler() {
        if (this.isAdmin) return;
        if (this.button.carouselMedia.length > this.maxCarouselCount - 1) {
          this.carouselMenuProps.disabled = true;
        } else {
          this.carouselMenuProps.disabled = false;
        }
      }
    }
  },
  methods: {
    loadContracts() {
      EnumUtils.loadEnum('buttonMode','display/elevator','button-mode',
        (response) => {
          this.buttonContent = response;
        }
      );
    },
    loadCarouselAndButtonContent() {
      ButtonContentService.getButtonCarouselContents(
        (response) => {
          this.buttonContentList = response.data.buttonContent;
          this.carouselContentList = response.data.carouselContent;
        }
      );
    },
    initialization(elevator) {
      this.button = new ButtonContent();
      this.$refs.form.reset();

      if (this.isAdmin) {
        this.$refs.additionalElevator.loadElevatorByElevatorCustormer(elevator);
      } else {
        this.$refs.additionalElevator.elevatorLoaded(elevator);
      }

      this.$store.commit('display/elevatorForm/updateButtonContent',this.button);

      ButtonContentService.readFromAPI(
        elevator.id,
        (response) => {
          this.button = response.data;
          this.modeType = this.button.buttonMode;
          this.dialog = true;
          this.$refs.dirtyDialog.setDirty(false);
          this.buttonBeforeChange = Object.assign({}, this.button);
          this.maxCarouselCount = response.data.carouselCount;

          this.disableOrEnableCarousel(this.maxCarouselCount);


          this.$watch('button',
            () => {
              this.$refs.dirtyDialog.setDirty(false);
              if (JSON.stringify(this.buttonBeforeChange) !== JSON.stringify(this.button)) {
                this.$refs.dirtyDialog.setDirty(true)
              }
            },
            {deep: true}
          );
        },
        () => {
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('display/elevator:edit.snackbar.button-content')}));
        }
      );

      if (!this.isAdmin) {
        this.$store.commit('display/elevatorForm/setElevator', elevator);
        this.$store.commit('display/elevatorForm/updateForm');
      }
    },
    disableOrEnableCarousel () {
      if (this.isAdmin) return;

      for (let i = 0; i < this.buttonContent.length; i++) {
        if (this.buttonContent[i].id === 'CAROUSEL_MODE') {
          this.buttonContent[i].disabled = this.maxCarouselCount === 0;
          break;
        }
      }
    },
    updateForm() {
      if (this.$store.state.display.elevatorForm.elevator.additionalElevators !== null) {
        this.button.additionalIds = this.$store.state.display.elevatorForm.elevator.additionalElevators;
      }

      ButtonContentService.putToAPI(
          this.button,
          () => {
            Utils.showSuccessSnackbar(this.$t('snackbar:edit-success', {name: this.$t('display/elevator:edit.snackbar.button-content')}));
          },
          () => {
            Utils.showFailureSnackbar(this.$t('snackbar:edit-failure', {name: this.$t('display/elevator:edit.snackbar.button-content')}));
          }
      );

      this.closeForm();
    },
    closeForm() {
      this.dialog = false;
      this.$refs.additionalElevator.deSelectAll();
    },
    updateMedia(value) {
      //values only contains list of ids, so have to collect name information again
      let selectedMedias = new Map();
      for(let i = 0; i < value.length; i++) {
        let media = this.getMediaByObject(value[i]);
        if (media !== null) {
          selectedMedias.set(media.value, media.key);
        }
      }
      //afterwards sort by the name.
      selectedMedias = new Map([...selectedMedias.entries()].sort(function (a, b) {
        return a[0].toLowerCase().localeCompare(b[0].toLowerCase());
      }));
      //push the id list back to our autocomplete field
      let sortedMedia = [];
      for (let [, value] of selectedMedias) {
        sortedMedia.push(value);
      }
      this.button.carouselMedia = sortedMedia;
    },
    getMediaByObject(id) {
      for(let i = 0; i < this.carouselContentList.length; i++) {
        if (this.carouselContentList[i].key === id) {
          return this.carouselContentList[i];
        }
      }

      return null;
    },
    getTextWidth(textTocheck) {
      if (!textTocheck) return;
      const canvas = document.getElementById("buttonCanvas");
      const ctx = canvas.getContext("2d");
      let text = ctx.measureText(textTocheck);

      return text.width;
    },
    setSymbols() {
      this.symbols = ['←', '→'];
    },
    addSymbol(symbol, model) {
      this.button[model] += symbol;
    }
  },
  created() {
    this.setSymbols();
    this.loadCarouselAndButtonContent();
    this.loadContracts();

  }
}
</script>
<style lang="scss" >
#buttonCanvas {
  display: none;
}

.warning-message {
  color: var(--v-warning-base);
}
.warning-message fieldset {
  border-color: var(--v-warning-base) !important;
}

.warning-message .v-label, .warning-message .v-icon {
  color: var(--v-warning-base) !important;
}
.text-button {
  .v-input__append-inner {
    margin-top: 0;
  }
}
</style>
